import { Episode, Project } from '../../../types';

type Translate = (key: string, options?: Record<string, unknown>) => string;

/**
 * 全集分集状态的"等待中"细分文案：draft/pending 阶段 StatusBadge 无法区分的子状态
 * （等待改写 / 等待代词标注 / 等待资产分析 / 等待分镜）。返回 undefined 时由
 * StatusBadge 按 episode.status 自身渲染（改写中 / 代词消解中 / 失败 / 已完成等）。
 *
 * 分镜页侧栏 EpisodeNavSidebar 与剧本信息页的全集分集状态卡片两边复用此函数，
 * 保证两处状态判定完全一致（§4 Phase 4：抽共享 getEpisodeProgressState）。
 */
export function getEpisodeProgressLabel(
  episode: Episode,
  project: Project,
  analysisStatus: string | undefined,
  t: Translate,
): string | undefined {
  if (episode.status === 'draft' || episode.status === 'pending') {
    if (project.enableScriptNormalization && !episode.normalizedContentURL) {
      return t('episodes.waitingForRewrite');
    }
    if (!episode.annotatedContentURL) {
      return t('episodes.waitingForPronounResolve');
    }
    return analysisStatus === 'completed' || analysisStatus === 'extracted'
      ? t('episodes.waitingForShots')
      : t('episodes.waitingForAnalysis');
  }
  return undefined;
}

/**
 * 该集是否处于「等待生成分镜」状态（结构判定，等价于 getEpisodeProgressLabel 返回
 * waitingForShots 的分支）：草稿/待处理 + 已改写(如启用) + 已代词消解 + 资产分析已就绪。
 * 剧本信息页据此判断「全部分集都等待生成分镜」时才展示「生成全部分镜提示词」按钮。
 */
export function isWaitingForShots(episode: Episode, project: Project, analysisStatus: string | undefined): boolean {
  if (episode.status !== 'draft' && episode.status !== 'pending') return false;
  if (project.enableScriptNormalization && !episode.normalizedContentURL) return false;
  if (!episode.annotatedContentURL) return false;
  return analysisStatus === 'completed' || analysisStatus === 'extracted';
}
